import type { SchemaInput } from '../shared/schema-input.js';
import { z } from 'zod';
const KEY = 'drawonamap:offline-account';

// This is a local storage partition, never proof of authorization to the server.
export function rememberOfflineAccount(id: string | number | null): void {
  try {
    if (id === null) localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, String(id));
  } catch { /* A blocked storage partition disables account draft recovery. */ }
}
export function offlineAccountId(): string | null {
  try { return localStorage.getItem(KEY); } catch { return null; }
}
export function offlineAccountScope(mapId: string): string | null {
  try {
    const id = localStorage.getItem(KEY);
    return id ? `account:${id}:map:${mapId}` : null;
  } catch { return null; }
}

export function rememberOfflineAuthUser(user: SchemaInput): void {
  const parsed = z.object({ id: z.union([z.string(), z.number()]) }).safeParse(user);
  if (parsed.success) rememberOfflineAccount(parsed.data.id);
  else if (!user) rememberOfflineAccount(null);
}
